import React, { Component } from 'react';
import {createMarkup} from './Factory';

class KalenderAnmelden extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);	
		this.handleSubmit = this.handleSubmit.bind(this);	
		this.handleName = this.handleName.bind(this);	
		this.handleSurname = this.handleSurname.bind(this);	
		this.handleEmail = this.handleEmail.bind(this);	
		this.handleTelephone = this.handleTelephone.bind(this);	
		this.handleDescription = this.handleDescription.bind(this);	
		this.handlechildrenName = this.handlechildrenName.bind(this);	
		this.handlechildrenSurname = this.handlechildrenSurname.bind(this);	
		this.handlechildrenAge = this.handlechildrenAge.bind(this);	
		this.addMore = this.addMore.bind(this);	
		this.handleCheck3 = this.handleCheck3.bind(this);
		this.formType = this.props.formType;
		this.state = { 
						kalender:this.props.kalender,
						kontakt: {
								name:'',
								surname:'',
								email:'',
								telefone: '',
								},
						children: [
									{
										name:'',
										surname:'',
										age:''
									}
								],
						remark:'',
						submitted:false,
						sucess:false,
						fail:false,
						checkbox3:'',
						checkbox3Error:'',
						submitLabel:this.props.staticData.label_anmelden
		}
	}
	handleCheck3(){
		this.setState({
			checkbox3:this.checkbox3.checked
		});
	}
	addMore(){
		this.setState({
			children: [...this.state.children,
						{
							name:'',
							surname:'',
							age:''						
						}
					],
		})
	}
	handlechildrenName(index,dis){
		let val = dis.refs['childrenName-'+index].value;
		const items = this.state.children;
		items[index].name = val;
		this.setState({
			items
		});
	}
	handlechildrenSurname(index,dis){
		let val = dis.refs['childrenSurname-'+index].value;
		const items = this.state.children;
		items[index].surname = val;
		this.setState({
			items
		});
	}
	handlechildrenAge(index,dis){
		let val = dis.refs['childrenAge-'+index].value;
		const items = this.state.children;
		items[index].age = val;
		this.setState({
			items
		});
	}
	handleSurname(){
		let {name,email,telefone} = this.state.kontakt;
		this.setState({
			kontakt: {
					surname:this.surname.value,
					name:name,
					email:email,
					telefone: telefone,
			}
		});
	}
	handleName(){
		let {surname,email,telefone} = this.state.kontakt;
		this.setState({
			kontakt: {
					name:this.name.value,
					surname:surname,
					email:email,
					telefone: telefone,
			}
		});
	}
	handleEmail(){
		let {surname,name,telefone} = this.state.kontakt;
		this.setState({
			kontakt: {
					name:name,
					surname:surname,
					email:this.email.value,
					telefone: telefone,
			}
		});
	}
	handleTelephone(){
		let {surname,name,email} = this.state.kontakt;
		this.setState({
			kontakt: {
					name:name,
					surname:surname,
					email:email,
					telefone: this.telefone.value,
			}
		});
	}
	handleDescription(){
		this.setState({
			remark: this.description.value
		});
	}
	handleClick(){
		this.props.handleClick();		
		this.setState({
			submitted:false,
			sucess:false
		});
	}
	handleSubmit(e){
		e.preventDefault();
		this.setState({
			submitLabel:this.props.staticData.label_newsletter_progress
		})
		let dis = this;
		let children = false;
		
		if(this.state.kontakt.name===''){
			this.name.focus(); 
			return false;
		}
		if(this.state.kontakt.surname===''){
			this.surname.focus(); 
			return false;
		}
		if(this.state.kontakt.email===''){
			this.email.focus(); 
			return false;
		}
		
		if(this.state.kontakt.telefone==='' && this.formType===1){
			this.telefone.focus(); 
			return false;
		}

		if(this.formType===3){
			this.state.children.map( (data,i)=>{
				if(this.refs['childrenName-'+i].value===''){
					this.refs['childrenName-'+i].focus();	
					children = true;
					return false;
				}
				if(this.refs['childrenAge-'+i].value===''){
					this.refs['childrenAge-'+i].focus();
					children = true;
					return false;
				}
				return '';
			});
			if(children)
				return false;
		}

		if(this.state.checkbox3==='' || !this.state.checkbox3){
			this.setState({
				checkbox3Error:'formError'
			})	
			return false;
		}
		{			
			
			let kontakt = JSON.stringify(this.state.kontakt);
			let children = JSON.stringify(this.state.children);
			let xhttp = new XMLHttpRequest();
			xhttp.open("POST", document.ajaxPath, true);
			xhttp.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
			xhttp.send("type="+this.formType+"&perform="+this.props.perform+"&kalender="+this.props.kalender+"&event_date="+this.props.eventdate+"&event_time="+this.props.kalenderTime+"&action=kalender_form_data&kontakt="+kontakt+"&lang="+document.language);
			xhttp.onreadystatechange = function() {
			  if (this.readyState === 4 && this.status === 200) {
				document.getElementById("myForm").reset();
				if(this.responseText==="Success"){
					dis.setState({
						submitted:true,
						sucess:true,
						checkbox3Error:'',
						submitLabel:dis.props.staticData.label_anmelden
					});
				}else{ 
					dis.setState({
						submitted:true,
						fail:true,
						checkbox3Error:'',
						submitLabel:dis.props.staticData.label_anmelden
					});
				}				
			  }
			};
			
		}	
	}
	
	render() {			
	   const {status,sucess_headline,sucess_text,error_headline,error_text,perform,formType,kalender}  = this.props;		
	   const { 
				label_vorname,label_nachname,label_telefonnummer,label_alter,label_email,label_obligatory,
				label_info_child,label_add_child,label_anmerkungen,label_anmelden,label_conclude,label_required,label_info_heading,label_info_heading_2
			} = this.props.staticData;
		let fheading = label_info_heading;
		if(formType==3){
			fheading = label_info_heading_2;	
		}
		
	   return (
			<div className={`fixed-overlay ${status} `}>
				<div className="overlay-wrapper">
					<i onClick={this.handleClick} className="close-overlay icon-close"></i>
					{
					(!this.state.submitted) ?
						<form id="myForm" className="clearfix" onSubmit={this.handleSubmit} >
							<h1 className="overlay-title" dangerouslySetInnerHTML={createMarkup(fheading)}></h1>
							{
								(formType==3)?
									<p style={{marginTop:'10px'}} dangerouslySetInnerHTML={createMarkup(kalender)}></p>
								:
									null	
							}
							<label className="margin-top-30" htmlFor="name">{label_vorname}*</label>
							<input onChange={this.handleName} name="name" type="text" ref={(input) => { this.name = input; }} />
							<label htmlFor="vorname">{label_nachname}*</label>
							<input onChange={this.handleSurname} id="vorname" type="text" ref={(input) => { this.surname = input; }}/>
							<label htmlFor="email">{label_email}*</label>
							<input onChange={this.handleEmail} id="email" type="email" ref={(input) => { this.email = input; }}/>		
							<label htmlFor="tel">{label_telefonnummer}{(formType===1)?'*':''}</label>
							<input onChange={this.handleTelephone} id="tel" type="tel" ref={(input) => { this.telefone = input; }}/>	

							{
								(formType==1)?
								<div>
									<h1 className="overlay-title margin-top-20">{label_info_child}</h1>
									{
										this.state.children.map( (data,i)=>{
											return (
												<div key={i}>
													<label className="margin-top-30" htmlFor="vorname2">{label_vorname}*</label>
													<input ref={`childrenName-${i}`} onChange={ () => this.handlechildrenName(i,this) } id="vorname2" type="text" />
													<label htmlFor="surname">{label_nachname}*</label>
													<input ref={`childrenSurname-${i}`} onChange={ () => this.handlechildrenSurname(i,this) } id="surname" type="text" />
													<label htmlFor="alter">{label_alter}*</label>
													<input ref={`childrenAge-${i}`} onChange={ () => this.handlechildrenAge(i,this) } id="alter" type="text" />
												</div>
											)
										})
									}
									<div className="add-children" onClick={this.addMore}>
										<i className="icon-add-white"></i>
										<span className="icon-add-label">{label_add_child}</span>
									</div>                
									<label htmlFor="tel">{label_anmerkungen}</label>
									<textarea onChange={this.handleDescription} rows="4" ref={(input) => { this.description = input; }}></textarea>
								</div>
								:
								null
							}
							
							<label className="pull-left required">*{label_required}</label>
							<div className={`formcheck ${this.state.checkbox3Error}`}>
								<div className="newsletter">
									<div className="newsletter-options">
										<div className="checkgroup">
											<input value="1" onChange={this.handleCheck3} ref={(input) => { this.checkbox3 = input; }} aria-label={label_obligatory} type="checkbox" id="newsletter-option3" />
											<label className="obligatory" htmlFor="newsletter-option3"></label>
											<span dangerouslySetInnerHTML={createMarkup(label_obligatory)}></span>
										</div>
									</div>
								</div>
							</div>
							<div className="clearfix"></div>
							<input type="submit" className="btn dark-btn pull-right" value={this.state.submitLabel} />
						</form>
					: 	(this.state.sucess) ?
						<div>
							<h1 className="overlay-title">{sucess_headline}</h1>
							<p className="margin-top-30">{sucess_text}</p>
							<input type="button" className="btn dark-btn pull-right margin-top-30" value={label_conclude} onClick={this.handleClick} />
						</div>
						:
						<div>
							<h1 className="overlay-title">{error_headline}</h1>
							<p className="margin-top-30">{error_text}</p>
							<input type="button" className="btn dark-btn pull-right margin-top-30" value={label_conclude} onClick={this.handleClick} />
						</div>
					}	
				</div>
			</div>
		)
	   
	}
}
export default KalenderAnmelden;


// WEBPACK FOOTER //
// ./src/components/KalenderAnmelden.js